<div
  class="sticky-zip-cta"
  [class.sticky-zip-cta--visible]="stickyZipCtaService.visible()"
  [attr.aria-hidden]="!stickyZipCtaService.visible()"
>
  <div class="sticky-zip-cta__inner">
    <app-new-roof-cost-zip-form
      placeholder="Enter your zip code"
      [fetchedZipcode]="fetchedZipcode"
      [(value)]="zipVal"
    />
  </div>
</div>
